import { ReactElement, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import tools from "utils/tools";
import specific from "../../Specific";

const Attributes = ({ form, setForm, specifics, images, colors }) => {
  const [selected, setSelected] = useState<any>(form?.attributes || {});
  const dispatch = useDispatch();
  const list = () => {
    const rows: ReactElement[] = [];
    const data = Object.entries(form?.specifics).filter(
      ([key, value]: any) => value.isAttribute,
    );
    let selectedSpecificValues = [];
    specifics?.map((e) =>
      e.specificValues.map((j) => selectedSpecificValues.push(j)),
    );
    // selectedSpecificValues = selectedSpecificValues.filter(e => data.map(([key, value]: any) => value.value).includes(e.slug))
    let selectedSpecificKeys = specifics.filter((e) =>
      data.map(([key, value]: any) => key).includes(e.slug.toString()),
    );
    Object.entries(selected).map(([primaryKey, primaryValue], index) => {
      rows.push(
        <section
          className={`addProductInfo ${index % 2 !== 0 ? "backGround" : ""}`}
        >
          <div className="skuContainer">
            {selectedSpecificKeys.map((specific) => (
              <>
                <label className="sideBarTitle">{specific.title}</label>
                <select
                  className="selector1"
                  defaultValue={
                    form?.attributes[primaryKey]?.specifics
                      ? form?.attributes[primaryKey]?.specifics[specific.slug]
                      : ""
                  }
                  onChange={(input) => {
                    const data = form?.attributes[primaryKey] || {};
                    if (!data.specifics) data.specifics = {};
                    data.specifics[specific.slug] = input.target.value;
                    setSelected((prevState) => ({
                      ...prevState,
                      [primaryKey]: data,
                    }));
                  }}
                >
                  <option value="">انتخاب کنید</option>
                  {specific.specificValues.map((e) => (
                    <option value={e.slug}>{e.title}</option>
                  ))}
                </select>
              </>
            ))}
          </div>
          <div className="selectorContainer">
            <span className="input3">
              <label className="sideBarTitle">وضعیت</label>
              <select
                className="selector1"
                defaultValue={form?.attributes[primaryKey]?.status}
                onChange={(input) => {
                  const data = form?.attributes[primaryKey] || {};
                  data.status = input.target.value;
                  setSelected((prevState) => ({
                    ...prevState,
                    [primaryKey]: data,
                  }));
                }}
              >
                <option value={0}>غیر فعال</option>
                <option value={1}>فعال</option>
              </select>
            </span>
            <span className="input3">
              <label className="sideBarTitle">قیمت مصرف کننده</label>
              <input
                className="selector1"
                value={tools.formatPriceToStr(
                  form?.attributes[primaryKey]?.price || 0,
                )}
                onChange={(input) => {
                  const data = form?.attributes[primaryKey] || {};
                  data.price = tools.formatStrToPrice(input.target.value);
                  setSelected((prevState) => ({
                    ...prevState,
                    [primaryKey]: data,
                  }));
                }}
              />
            </span>
            <span className="input3">
              <label className="sideBarTitle">رنگ</label>
              <select
                className="selector1"
                defaultValue={form?.attributes[primaryKey]?.color}
                onChange={(input) => {
                  const data = form?.attributes[primaryKey] || {};
                  data.color = input.target.value;
                  setSelected((prevState) => ({
                    ...prevState,
                    [primaryKey]: data,
                  }));
                }}
              >
                <option value="">بدون رنگ</option>
                {colors?.map((e) => (
                  <option value={e.id}>{e.title}</option>
                ))}
              </select>
            </span>
            <span className="input3">
              <label className="sideBarTitle">تخفیف</label>
              <input
                className="lowInput"
                value={tools.formatPriceToStr(
                  form?.attributes[primaryKey]?.discountPrice || 0,
                )}
                onChange={(input) => {
                  const data = form?.attributes[primaryKey] || {};
                  data.discountPrice = tools.formatStrToPrice(
                    input.target.value,
                  );
                  setSelected((prevState) => ({
                    ...prevState,
                    [primaryKey]: data,
                  }));
                }}
              />
            </span>
          </div>
          <div className="dashImgContainer">
            {images?.map((image, index) => (
              <img
                key={image.id}
                alt={index}
                src={image.preview}
                className={`galleryImages${form?.attributes[primaryKey]?.imageId === image.id ? " selectedImage" : ""}`}
                onClick={() => {
                  const data = form?.attributes[primaryKey] || {};
                  data.imageId =
                    data.imageId === image.id ? undefined : image.id;
                  setSelected((prevState) => ({
                    ...prevState,
                    [primaryKey]: { ...data },
                  }));
                }}
              />
            ))}
          </div>
          <button
            className="deleteAttribute"
            onClick={() =>
              setSelected((prev) => {
                const next = { ...prev };
                delete next[primaryKey];
                return next;
              })
            }
          >
            حذف
          </button>
        </section>,
      );
    });

    return rows;
  };

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      attributes: selected,
    }));
  }, [selected]);

  return (
    <div className="AddInfoContainer">
      {form?.specifics && list()}
      <button
        className="dashboardHeader"
        onClick={() =>
          setSelected((prev) => ({
            ...prev,
            [Object.values(selected).length]: {
              status: 1,
              price: form?.price,
              discountPrice: form?.discountPrice,
            },
          }))
        }
      >
        افزودن +
      </button>
    </div>
  );
};

export default Attributes;
